import Modal from "./Modal";
import "./Modal.css";
import { PARAMETER_MAP } from "../../util/PARAMETER_MAP";
import { formatMetric } from "../../util/formatValue";

function resolveParamName(parameterName, parameterId) {
  if (parameterName) return parameterName;
  return PARAMETER_MAP?.[parameterId]?.name ?? (parameterId ? `${parameterId}` : "--");
}

function formatTimestamp(dado) {
  if (!dado) return "--";

  const date =
    typeof dado === "number"
      ? new Date(dado < 1e12 ? dado * 1000 : dado)
      : new Date(dado);

  //Caso não seja possível converter a data
  if (Number.isNaN(date.getTime())) return "--";

  const options = { timeZone: "America/Sao_Paulo" };

  return `${date.toLocaleTimeString("pt-BR", options)} • ${date.toLocaleDateString("pt-BR", options)}`;
}

function SingleAlert({ alert }) {
  const paramMeta = PARAMETER_MAP?.[alert.parameterId];
  const paramName = resolveParamName(alert.parameterName, alert.parameterId);
  const paramCode = paramMeta?.code ? `(${paramMeta.code})` : "";
  const unit = paramMeta?.unit;

  const formattedValue = alert.parameterValue !== undefined
    ? formatMetric(alert.parameterValue, { unit, decimals: 2 })
    : "--";

  const hasStructuredData =
    alert.parameterId !== undefined ||
    alert.tremId !== undefined ||
    alert.carro !== undefined;

  const message = hasStructuredData
    ? `${alert.message ?? "Alerta crítico"}


      Trem: ${alert.tremNome ?? alert.tremId}
      Carro: ${alert.carro ?? "--"}
      Parâmetro: ${paramName} ${paramCode}
      Valor: ${formattedValue}

      Horário: ${formatTimestamp(alert.messageTimestamp ?? alert.createdAt)}`
    : alert.message ?? "Alerta crítico";

  return <p>{message}</p>;
}

const TRAIN_COLORS = ["#2563eb", "#16a34a", "#9333ea", "#ea580c"];

function BatchAlerts({ alerts }) {
  const sorted = [...alerts].sort((a, b) => {
    const nameA = (a.tremNome ?? `Trem ${a.tremId}`).toLowerCase();
    const nameB = (b.tremNome ?? `Trem ${b.tremId}`).toLowerCase();
    return nameA.localeCompare(nameB, "pt-BR");
  });

  const trainNames = [...new Set(sorted.map(a => a.tremNome ?? `Trem ${a.tremId}`))];
  const colorMap = Object.fromEntries(
    trainNames.map((name, i) => [name, TRAIN_COLORS[i % TRAIN_COLORS.length]])
  );

  return (
    <div>
      <p className="batch-title">
        {alerts.length} alertas críticos
      </p>
      <div className="batch-train-tags">
        {trainNames.map(name => (
          <span
            key={name}
            className="batch-train-tag"
            style={{ color: colorMap[name], border: `1px solid ${colorMap[name]}` }}
          >
            {name}
          </span>
        ))}
      </div>
      <div className="batch-list">
        {sorted.map((alert, key) => {
          const paramMeta = PARAMETER_MAP?.[alert.parameterId];
          const paramName = resolveParamName(alert.parameterName, alert.parameterId);
          const unit = paramMeta?.unit;

          const formattedValue = alert.parameterValue !== undefined
            ? formatMetric(alert.parameterValue, { unit, decimals: 2 })
            : "--";

          const trainName = alert.tremNome ?? `Trem ${alert.tremId}`;

          return (
            <div key={key} className="batch-item">
              <div className="batch-item-header">
                <span style={{ color: colorMap[trainName] }}>{trainName}</span>
                {" — Carro "}{alert.carro ?? "--"}
              </div>
              <div>Parâmetro: {paramName} </div>
              <div>Valor: {formattedValue} {unit}</div>
              <div className="batch-item-timestamp">
                {formatTimestamp(alert.messageTimestamp ?? alert.timestamp ?? alert.createdAt)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function CriticalAlertModal({ alerts, onClose }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <Modal show={true} type="error" onClose={onClose}>
      {alerts.length === 1
        ? <SingleAlert alert={alerts[0]} />
        : <BatchAlerts alerts={alerts} />
      }
    </Modal>
  );
}
